import { SideBar } from '../../components';
import { connect } from 'react-redux';
import { userSignOut } from 'actions/Auth';
import { Dispatch } from 'redux';
import { RootState } from 'model/state';
import { createStructuredSelector } from 'reselect';
import { User } from 'model';
import { selectLoggedUser } from 'selectors/Auth';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onLogout: (history: any) => dispatch(userSignOut(history)),
});

const mapStateToProps = createStructuredSelector<RootState, { user?: User }>({
  user: selectLoggedUser()
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);